/**
 * Javascript file for the footer.
 * @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart
 */

import { required, sameAs, email, minLength } from "vuelidate/lib/validators";
import auth from "../../../auth";
export default {
  name: "WernerFooter",

  /**
   * The vue instance's data object.
   * @property {boolean} loggedIn - Status of the user's login.
   * @property {boolean} sending - Information is currently being processed.
   * @property {object} form.firstName - The user's first name. 
   * @property {object} form.lastName -The user's last name.
   * @property {object} form.gender - The user's gender.
   * @property {string} form.email - The user's email.
   * @property {boolean} form.letter- Users choice for newsletter subscription
   * @property {boolean} newsletter - User subscribed to the newsletter.
   * @property {boolean} saved - Changes were saved.
   */
  data() {
    return {
      loggedIn: auth.loggedIn(),
      sending: false,
      error: false,
      form: {
        firstname: null,
        lastname: null,
        gender: null,
        email: "",
        letter: false
      },
      newsletter: false,
      saved: false
    };
  },

  /**
   * Validation to be done to the data.
   * @property {*} form.firstName - Validation to be done to the entered first name.
   * @property {*} form.lastName - Validation to be done to the entered last name.
   * @property {*} form.gender - Validation to be done to the entered gender.
   * @property {*} form.email - Validation to be done to the entered email.
   */
  validations: {
    form: {
      firstname: {
        required,
        minLength: minLength(3)
      },
      lastname: {
        required,
        minLength: minLength(3)
      },
      gender: {
        required
      },
      email: {
        required,
        email
      }
    }
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Determines if the field is invalid or not.
     * @param {string} fieldName - The name of the field.
     */
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },

    /**
     * Validates the data.
     * If the data is valid, sign the user up for the newsletter.
     */
    validateData() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.newsletter = false;
        this.signupForNewsletter();
      }
    },

    /**
     * Signs up the user to the newsletter.
     */
    signupForNewsletter() {
      this.sending = true;
      auth
        .registerForNewsletter(
          this.form.email,
          this.form.firstname,
          this.form.lastname,
          this.form.gender
        )
        .then(() => {
          this.sending = false;
          this.saved = true;
        })
        .catch(err => {
          //console.log(err);
          this.sending = false;
          this.error = true;
        });
    },

    /**
     * Restores the state the page was in if the user had already visited 
     * it in the current session.
     */
    setBeenHere() {
      setCookie("acceptedCookie", "true", 365);
      location.reload();
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/footer/footer.js